import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useUsersList() {
  // Use toast
  const toast = useToast()

  const refUserListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'photo', sortable: true },
    { key: 'name', label: "Instructor", sortable: true },
    { key: 'profession', label: "Profession", sortable: true },

    { key: 'status', label: "Status", sortable: true },


    { key: 'actions' },
  ]
  const perPage = ref(10)
  const totalUsers = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const roleFilter = ref(null)
  const planFilter = ref(null)
  const statusFilter = ref(null)
  const items = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = items.value ? items.value.length : 0
    var from = perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0)
    return {
      from: from,
      to: (from + perPage.value) > totalUsers.value ? totalUsers.value + 1 : from + perPage.value,
      of: totalUsers.value,
    }
  })

  const refetchData = () => {
    fetchInstructers()
    // refUserListTable.value.refresh()
  }

  watch([], () => {
    refetchData()
  })

  const fetchInstructers = (ctx, callback) => {
    store
      .dispatch('apps-instructor/fetchInstructers', {

      })
      .then(response => {
        const { data } = response.data
        items.value = data
        totalUsers.value = items.value.length
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching users list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }
  fetchInstructers()
  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveUserRoleVariant = role => {
    if (role === 'subscriber') return 'primary'
    if (role === 'author') return 'warning'
    if (role === 'maintainer') return 'success'
    if (role === 'editor') return 'info'
    if (role === 'admin') return 'danger'
    return 'primary'
  }

  const resolveUserRoleIcon = role => {
    if (role === 'subscriber') return 'UserIcon'
    if (role === 'author') return 'SettingsIcon'
    if (role === 'maintainer') return 'DatabaseIcon'
    if (role === 'editor') return 'Edit2Icon'
    if (role === 'admin') return 'ServerIcon'
    return 'UserIcon'
  }

  const resolveUserStatusVariant = status => {
    if (status === 0) return 'warning'
    if (status === 1) return 'success'
    if (status === 2) return 'secondary'
    return 'primary'
  }
  const resolveUserStatusVariantText = status => {
    if (status === 0) return 'deleted'
    if (status === 1) return 'active'
    if (status === 2) return 'disabled'
    return 'primary'
  }

  return {
    fetchInstructers,
    tableColumns,
    perPage,
    currentPage,
    totalUsers,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refUserListTable,
    items,

    resolveUserRoleVariant,
    resolveUserRoleIcon,
    resolveUserStatusVariant,
    resolveUserStatusVariantText,
    refetchData,

    // Extra Filters
    roleFilter,
    planFilter,
    statusFilter,
  }
}
